import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumber from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import httpService from "../../../../../services/httpServices/httpServices";
import Pagination from "../../../../partials/content/Pagination";

export default function All() {
  const params = useParams();
  const userID = params.userID;

  const [currentPage, setCurrentPage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [allNoteCallUsers, setAllNoteCallUsers] = useState([]);

  useEffect(() => {
    getAllNoteCallUsers();
  }, [currentPage, countItemPerPage]);

  const getAllNoteCallUsers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allNoteCallUsers = await sendRequestGetAllNoteCallUsers(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!allNoteCallUsers) {
      return;
    }

    setAllNoteCallUsers(allNoteCallUsers.note_calls_user);
    setCountPage(allNoteCallUsers.count_page);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllNoteCallUsers = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/user/all-note-call/${userID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const paginationItemOnClickHandler = (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generateHtmlTagAllNoteCallUsers = () => {
    return (
      <>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره یادادشت تماس</td>
                <td>کاربر مکالمه کننده </td>
                <td> عنوان </td>
                <td>تاریخ درج</td>
                <td>تاریخ آخرین بروزرسانی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allNoteCallUsers.map((noteCallUsers, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{noteCallUsers.unc_id}</td>
                    <td>{noteCallUsers.caller_user}</td>
                    <td>{noteCallUsers.unc_title}</td>
                    <td>
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          noteCallUsers.unc_created_at
                        ) +
                          " " +
                          noteCallUsers.unc_created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          noteCallUsers.unc_updated_at
                        ) +
                          " " +
                          noteCallUsers.unc_updated_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <span className="pl-2">
                        <Link
                          to={`/user/manage/${userID}/note-call/view/${noteCallUsers.unc_id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                      <Link
                        to={`/user/manage/${userID}/note-call/edit/${noteCallUsers.unc_id}`}
                        className="btn btn-success"
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="لیست یادادشت تماس ها با کاربر" />

        <section className="content pt-5">
          <div className="card" id="select-position-container">
            <div className="card-body">
              <div className="d-flex justify-content-between pb-2">
                <Link
                  to={`/user/manage/${userID}/note-call/add`}
                  className="btn btn-success"
                >
                  <span className="pl-2">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>یادداشت جدید</span>
                </Link>
                <Link
                  to={`/user/show-info-user/${userID}`}
                  className="btn btn-primary"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>
                {allNoteCallUsers.length == 0 ? (
                  <p className="alert alert-info">
                    این کاربر هیچ یادادشت تماسی ندارد
                  </p>
                ) : (
                  generateHtmlTagAllNoteCallUsers()
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
